import React from "react";
import './coursesoffstyle.css';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";
import choseaccount from '../../imagesHome/game02.png';
import SocialLoginRegistrer from './SocialLoginRegistrer';
import Registrercourse from './Registrercourse';

const PageGameTypeAccountOff = () => {
  return (
    <div className="general-frame-bc-cf">
    <div className="general-frame-game-blue">
      {/* 🔹 Breadcrumb */}
     

      <div className="game-hero-section-blue">
        {/* 🔹 Stânga - Titlu și descriere */}

        <div className="breadcrumb-game-blue">
          <span>Jocuri</span>
          <FontAwesomeIcon icon={faChevronRight} className="breadcrumb-game-blue-icon" />
          <span className="current">Identifica tipul contului</span>
        </div>
        <div className="game-hero-content-blue">

       <div className="game-hero-left-blue">
  <img src={choseaccount} alt="identifica tipul contului" />
  <h1>Identifica tipul contului</h1>
  <p>
    Testeaza-ti cunostintele despre clasificarea conturilor contabile!
    Acest joc interactiv te ajuta sa distingi rapid intre active, pasive,
    venituri si cheltuieli.
  </p>
  <p>
    Primesti un cont sau o situatie si trebuie sa identifici corect categoria
    din care face parte. Vei invata sa recunosti tipurile de conturi instant,
    o abilitate esentiala in contabilitate.
  </p>
  <p>
    Perfect pentru a-ti fixa cunostintele despre structura bilantului si
    contului de profit si pierdere!
  </p>
</div>


        {/* 🔹 Dreapta - card/formular */}
        <div className="game-hero-right-blue">
          <div className="game-card-blue">
            <h2>Inregistreaza-te gratuit pe ContaLearn</h2>
            <p>Acceseaza jocul si invata sa clasifici conturile corect!</p>
          

               <div><Registrercourse /></div>
               <div className="sau-game-blue">sau</div>
               <div><SocialLoginRegistrer /></div>
          </div>
        </div>
        </div>
      </div>

    

    </div>
      
      {/* 🔹 Secțiunea 2: Ce vei învăța */}
      <div className="game-learn-section-blue">
        <div className="game-learn-container-blue">
          <h2 className="game-section-title-blue">Ce vei exersa in acest joc</h2>
          <p className="game-section-subtitle-blue">
            Invata sa distingi rapid intre diferite tipuri de conturi si sa le clasifici corect.
          </p>

          <div className="game-cards-grid-blue">
            {/* Exemplu 1 */}
            <div className="game-feature-card-blue">
              <span className="game-card-icon-blue">🏦</span>
              <h3 className="game-card-title-blue">Conturi de active</h3>
              <p className="game-card-desc-blue">
                Identifica conturile care reprezinta ceea ce detine firma: bani, stocuri, cladiri, echipamente.
              </p>
            </div>

            {/* Exemplu 2 */}
            <div className="game-feature-card-blue">
              <span className="game-card-icon-blue">📊</span>
              <h3 className="game-card-title-blue">Conturi de pasive</h3>
              <p className="game-card-desc-blue">
                Recunoaste conturile care arata datoriile firmei: credite bancare, furnizori, salarii de plata.
              </p>
            </div>

            {/* Exemplu 3 */}
            <div className="game-feature-card-blue">
              <span className="game-card-icon-blue">💰</span>
              <h3 className="game-card-title-blue">Conturi de venituri</h3>
              <p className="game-card-desc-blue">
                Descopera conturile care inregistreaza incasarile: vanzari, servicii prestate, chirii incasate.
              </p>
            </div>

            {/* Exemplu 4 */}
            <div className="game-feature-card-blue">
              <span className="game-card-icon-blue">💳</span>
              <h3 className="game-card-title-blue">Conturi de cheltuieli</h3>
              <p className="game-card-desc-blue">
                Invata sa identifici cheltuielile: salarii, chirii platite, utilitati, materiale consumate.
              </p>
            </div>

            {/* Exemplu 5 */}
            <div className="game-feature-card-blue">
              <span className="game-card-icon-blue">⚖️</span>
              <h3 className="game-card-title-blue">Capitaluri proprii</h3>
              <p className="game-card-desc-blue">
                Recunoaste conturile de capitaluri: capital social, rezerve, profit nerepartizat.
              </p>
            </div>

            {/* Exemplu 6 */}
            <div className="game-feature-card-blue">
              <span className="game-card-icon-blue">🎯</span>
              <h3 className="game-card-title-blue">Situatii complexe</h3>
              <p className="game-card-desc-blue">
                Rezolva cazuri mai dificile unde trebuie sa gandesti logic despre natura contului.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* 🔹 Secțiunea 3: Cum funcționează jocul */}
      <div className="game-how-section-blue">
        <div className="game-how-container-blue">
          <h2 className="game-section-title-blue">Cum functioneaza jocul</h2>
          
          <div className="game-steps-grid-blue">
            <div className="game-step-item-blue">
              <div className="game-step-icon-blue">📋</div>
              <div className="game-step-number-blue">1</div>
              <div className="game-step-label-blue">Primesti un cont</div>
            </div>

            <div className="game-step-item-blue">
              <div className="game-step-icon-blue">🤔</div>
              <div className="game-step-number-blue">2</div>
              <div className="game-step-label-blue">Gandesti la natura lui</div>
            </div>

            <div className="game-step-item-blue">
              <div className="game-step-icon-blue">✅</div>
              <div className="game-step-number-blue">3</div>
              <div className="game-step-label-blue">Alegi categoria</div>
            </div>

            <div className="game-step-item-blue">
              <div className="game-step-icon-blue">🎯</div>
              <div className="game-step-number-blue">4</div>
              <div className="game-step-label-blue">Primesti feedback</div>
            </div>
          </div>
        </div>
      </div>

      {/* 🔹 Secțiunea 4: Beneficii */}
      <div className="game-benefits-section-blue">
        <div className="game-benefits-container-blue">
          <h2 className="game-section-title-blue">De ce sa joci acest joc</h2>
          
          <div className="game-benefits-list-blue">
            <div className="game-benefit-item-blue">
              <div className="game-benefit-check-blue">✓</div>
              <div>
                <h4>Viteza de recunoastere</h4>
                <p>Invata sa clasifici conturile instant, fara ezitare</p>
              </div>
            </div>

            <div className="game-benefit-item-blue">
              <div className="game-benefit-check-blue">✓</div>
              <div>
                <h4>Gandire logica</h4>
                <p>Dezvolta capacitatea de a analiza natura economica a conturilor</p>
              </div>
            </div>

            <div className="game-benefit-item-blue">
              <div className="game-benefit-check-blue">✓</div>
              <div>
                <h4>Pregatire pentru examen</h4>
                <p>Tipul de intrebari care apar frecvent in teste si examene</p>
              </div>
            </div>

            <div className="game-benefit-item-blue">
              <div className="game-benefit-check-blue">✓</div>
              <div>
                <h4>Fixeaza cunostintele</h4>
                <p>Prin repetitie inveti sa faci diferenta rapid intre tipuri</p>
              </div>
            </div>

            <div className="game-benefit-item-blue">
              <div className="game-benefit-check-blue">✓</div>
              <div>
                <h4>Esential pentru bilant</h4>
                <p>Fundamentul pentru a intelege structura bilantului contabil</p>
              </div>
            </div>

            <div className="game-benefit-item-blue">
              <div className="game-benefit-check-blue">✓</div>
              <div>
                <h4>Mod distractiv de invatare</h4>
                <p>Transformi o tema dificila intr-o activitate placuta</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* 🔹 Secțiunea 5: Final CTA */}
      <div className="game-final-cta-blue">
        <div className="game-cta-content-blue">
          <h2>Gata sa te testezi?</h2>
          <p>Inregistreaza-te gratuit si invata sa clasifici conturile ca un expert!</p>
          <div className="game-cta-buttons-blue">
            <Registrercourse />
            <div className="sau-game-cta-blue">sau</div>
            <SocialLoginRegistrer />
          </div>
        </div>
      </div>

    </div>
  );
};

export default PageGameTypeAccountOff;
